import { CustomRadioProps } from '../../../interfaces';
import { RadioWrapper } from './styles';
import './styles.scss';
import classNames from 'classnames';

const CustomRadio: React.FC<CustomRadioProps> = props => {
  const { className, type = 'primary', ...rest } = props;

  return (
    <RadioWrapper
      {...rest}
      className={classNames([
        className,
        'custom-radio',
        { primary: type === 'primary', linkage: type === 'linkage' },
      ])}
    />
  );
};

export default CustomRadio;
